import { KillWindowsProcessMessage, TaskDetailsAndroidMessage, TaskDetailsWindowsMessage, TaskListWindowsMessage, ThreadTimesWindowsMessage } from "../messages/pocket-com";
import { BaseCommand } from "./baseCommand";
import { RequestReplyService } from "../../remote-control-ng/services/requestReplyService"
import { InjectionContextCommand } from "../commandFactory";
import { Injector } from "@angular/core";

@InjectionContextCommand
export class TaskDetailsAndroidCommand extends BaseCommand<TaskDetailsAndroidMessage>{
    constructor(private injector: Injector) {
        super(TaskDetailsAndroidMessage);
    }
    protected doProcess(message: TaskDetailsAndroidMessage): void {
        this.injector.get(RequestReplyService).processReply(message);
    }

}

@InjectionContextCommand
export class TaskListWindowsCommand extends BaseCommand<TaskListWindowsMessage>{
    constructor(private injector: Injector) {
        super(TaskListWindowsMessage);
    }
    protected doProcess(message: TaskListWindowsMessage): void {
        this.injector.get(RequestReplyService).processReply(message);
    }
}

@InjectionContextCommand
export class TaskDetailsWindowsCommand extends BaseCommand<TaskDetailsWindowsMessage>{
    constructor(private injector: Injector) {
        super(TaskDetailsWindowsMessage);
    }
    protected doProcess(message: TaskDetailsWindowsMessage): void {
        this.injector.get(RequestReplyService).processReply(message);
    }
}

@InjectionContextCommand
export class ThreadTimesWindowsCommand extends BaseCommand<ThreadTimesWindowsMessage>{
    constructor(private injector: Injector) {
        super(ThreadTimesWindowsMessage);
    }
    protected doProcess(message: ThreadTimesWindowsMessage): void {
        this.injector.get(RequestReplyService).processReply(message, message.response, message.reqId);
    }
}

export class KillWindowsProcessCommand extends BaseCommand<KillWindowsProcessMessage>{
    constructor() {
        super(KillWindowsProcessMessage);
    }
    protected doProcess(message: KillWindowsProcessMessage): void {
        console.warn('PC_KILLTSK received, but there is no action required');
    }
}
